<div class="col no-overflow padding all full-width">
  <div class="row no-overflow">
    <mat-card class="no-overflow fill padding all full-width quick-actions-card">
      <!-- Header Section -->
      <div class="quick-actions-header">
        <div class="header-content">
          <div class="header-text">
            <h2 class="header-title">Quick Actions</h2>
            <p class="header-subtitle">Perform common actions on the current Key System</p>
          </div>
        </div>
      </div>

      <!-- Find Bitting Section -->
      <div class="action-section collapsible">
        <div class="section-header" (click)="toggleFindBittingSection()">
          <mat-icon class="section-icon">search</mat-icon>
          <div class="section-title-group">
            <h3 class="section-title">
              Find Bitting
              <span class="section-summary" *ngIf="!isFindBittingExpanded && getFindBittingSummary()">{{ getFindBittingSummary() }}</span>
            </h3>
            <p class="section-description" *ngIf="!isFindBittingExpanded">Search for a bitting in the current Key System</p>
          </div>
          <mat-icon class="collapse-icon" [class.expanded]="isFindBittingExpanded">
            expand_more
          </mat-icon>
        </div>

        <div class="section-content" [class.collapsed]="!isFindBittingExpanded">
          <!-- Search Controls -->
          <div class="search-controls-row">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Bitting Value</mat-label>
              <input matInput
                     placeholder="e.g., 054179"
                     [(ngModel)]="bittingSearchInput"
                     (keyup.enter)="searchBitting()">
              <mat-hint>Enter the bitting</mat-hint>
            </mat-form-field>

            <button mat-raised-button
                    color="primary"
                    class="search-button"
                    (click)="searchBitting()"
                    [disabled]="isSearching">
              <mat-icon>search</mat-icon>
              {{ isSearching ? 'Finding...' : 'Find' }}
            </button>

            <button mat-button
                    class="clear-button"
                    (click)="clearBittingSearch()">
              <mat-icon>clear</mat-icon>
              Clear All
            </button>
          </div>

          <!-- Loading State -->
          <div *ngIf="isSearching" class="search-loading">
            <mat-spinner diameter="30"></mat-spinner>
            <p>Searching for bitting...</p>
          </div>

          <!-- Results Display -->
          <div *ngIf="bittingSearchResults && bittingSearchResults.data.length > 0 && !isSearching" class="search-results">
            <table mat-table [dataSource]="bittingSearchResults" class="results-table">
              <!-- Key Set Symbol Column -->
              <ng-container matColumnDef="keySetSymbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">{{ element.keySetSymbol }}</td>
              </ng-container>

              <!-- Book Number Column -->
              <ng-container matColumnDef="bookNumber">
                <th mat-header-cell *matHeaderCellDef>Book Number</th>
                <td mat-cell *matCellDef="let element">{{ element.bookNumber }}</td>
              </ng-container>

              <!-- Key Section Column -->
              <ng-container matColumnDef="keySection">
                <th mat-header-cell *matHeaderCellDef>Key Section</th>
                <td mat-cell *matCellDef="let element">{{ element.keySection }}</td>
              </ng-container>

              <!-- Bitting Column -->
              <ng-container matColumnDef="bitting">
                <th mat-header-cell *matHeaderCellDef>Bitting</th>
                <td mat-cell *matCellDef="let element">{{ element.bitting }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <!-- No Results Found -->
          <div *ngIf="bittingSearchResults && bittingSearchResults.data.length === 0 && !isSearching" class="no-results">
            <mat-icon class="no-results-icon">search_off</mat-icon>
            <p>No results found for "{{ bittingSearchInput }}"</p>
          </div>
        </div>
      </div>

      <!-- Export Data Section -->
      <div class="action-section collapsible">
        <div class="section-header" (click)="toggleExportDataSection()">
          <mat-icon class="section-icon">file_download</mat-icon>
          <div class="section-title-group">
            <h3 class="section-title">
              Export Data
              <span class="section-summary" *ngIf="!isExportDataExpanded && getExportDataSummary()">{{ getExportDataSummary() }}</span>
            </h3>
            <p class="section-description" *ngIf="!isExportDataExpanded">Export Structure data as csv file</p>
          </div>
          <mat-icon class="collapse-icon" [class.expanded]="isExportDataExpanded">
            expand_more
          </mat-icon>
        </div>

        <div class="section-content" [class.collapsed]="!isExportDataExpanded">
          <!-- Export Controls -->
          <div class="export-controls-row">
            <mat-form-field appearance="outline" class="export-input">
              <mat-label>State Code(s)</mat-label>
              <input matInput
                     placeholder="e.g., CA, TX, NY"
                     [(ngModel)]="stateCode"
                     (keyup.enter)="exportData()">
              <mat-hint>Comma-separated state codes</mat-hint>
            </mat-form-field>

            <mat-checkbox
              [(ngModel)]="includeDealerSpec"
              class="margin top bottom dealer-spec-checkbox">
              Include DealerSpec
            </mat-checkbox>

            <button mat-raised-button
                    color="primary"
                    class="export-button"
                    (click)="exportData()">
              <mat-icon>file_download</mat-icon>
              Export CSV
            </button>

            <button mat-button
                    class="clear-button"
                    (click)="clearExport()">
              <mat-icon>clear</mat-icon>
              Clear All
            </button>
          </div>

          <!-- Export Success/Info Message -->
          <div *ngIf="exportMessage" class="export-message">
            <mat-icon>info</mat-icon>
            <p>{{ exportMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Future action sections can be added here -->
    </mat-card>
  </div>
</div>
